import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AttachmentEntityType, AttachmentResponse } from '../models/Attachment-model';

const BASE_PATHS: Record<AttachmentEntityType, string> = {
    pureOriginal: '/pureOriginals',
    master: '/master',
    version: '/version'
};

@Injectable({
    providedIn: 'root'
})
export class AttachmentService {
    private url = `${this.API_URL}`;

    constructor(
        @Inject('API_URL') private API_URL: string,
        private httpClient: HttpClient
    ) {}

    uploadAttachment(
        type: AttachmentEntityType,
        entityId: number,
        file: File
    ): Observable<HttpEvent<AttachmentResponse>> {
        const formData = new FormData();
        formData.set('file', file);
        const base = BASE_PATHS[type];
        return this.httpClient.post<AttachmentResponse>(
            `${this.url}${base}/${entityId}/attachments`,
            formData,
            { reportProgress: true, observe: 'events' }
        );
    }

    listAttachments(
        type: AttachmentEntityType,
        entityId: number
    ): Observable<AttachmentResponse[]> {
        const base = BASE_PATHS[type];
        return this.httpClient.get<AttachmentResponse[]>(
            `${this.url}${base}/${entityId}/attachments`
        );
    }

    deleteAttachment(
        type: AttachmentEntityType,
        attachmentId: number
    ): Observable<void> {
        const base = BASE_PATHS[type];
        return this.httpClient.delete<void>(
            `${this.url}${base}/attachments/${attachmentId}`
        );
    }

    downloadAttachment(
        type: AttachmentEntityType,
        attachmentId: number,
        fileName: string
    ): void {
        const base = BASE_PATHS[type];
        this.httpClient
            .get(`${this.url}${base}/attachments/${attachmentId}/download`, {
                responseType: 'blob'
            })
            .subscribe((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            });
    }

    downloadAttachmentBlob(
        type: AttachmentEntityType,
        attachmentId: number
    ): Observable<Blob> {
        const base = BASE_PATHS[type];
        return this.httpClient.get(
            `${this.url}${base}/attachments/${attachmentId}/download`,
            { responseType: 'blob' }
        );
    }
}
